export default __webpack_public_path__ + "static/media/feeling_proud.93881364.svg";